import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { getColor } from "../../../style/color/color";
import TextInput from "../../../commanComponents/financialsnapshot/TextInput";
import { Close } from "@mui/icons-material";
import CustomSnackbar from "../../../commanComponents/CustomerSnackbar";
import { StyledDatePicker } from "../../../style/styleComponents/StyledPolicyModel";
import DatePicker from "react-datepicker";
import { fonts } from "../../../style/fonts/fonts";
import { String } from "../../../constants/Strings";

const ProfiduntFundModel = ({ Title, open, handlClose, onSubmit, values }) => {
  const [PPFCards, setPPFCards] = useState({
    totalAmount: "",
    tenure: null,
  });
  const [EPFCards, setEPFCards] = useState({
    totalAmount: "",
    tenure: null,
  });
  const [alignment, setAlignment] = useState("PPF");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage] = useState("");

  const handleFieldChangePPF = (field, value) => {
    if (field === "tenure" && value instanceof Date && !isNaN(value)) {
      const year = value.getFullYear();

      setPPFCards((prev) => ({ ...prev, [field]: year.toString() }));
    } else {
      setPPFCards((prev) => ({ ...prev, [field]: value }));
    }
  };

  const handleFieldChangeEPF = (field, value) => {
    if (field === "tenure" && value instanceof Date && !isNaN(value)) {
      const year = value.getFullYear();
      setEPFCards((prev) => ({ ...prev, [field]: year.toString() }));
    } else {
      setEPFCards((prev) => ({ ...prev, [field]: value }));
    }
  };

  const handleToggleChange = (value) => {
    setAlignment(value);
  };

  useEffect(() => {
    if (values) {
      setPPFCards(values.PPF || 0);
      setEPFCards(values.EPF || 0);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleSave = () => {
    onSubmit({ PPF: PPFCards, EPF: EPFCards });
    handlClose(false);
  };

  return (
    <Card>
      <Dialog
        open={open}
        onClose={() => {
          handlClose(false);
        }}
        fullWidth
        sx={{
          width: "100%",
          maxWidth: "700px",
          overflowY: "auto",
          p: 1,
          "& .MuiPaper-root": {
            borderRadius: "16px",
          },
        }}
      >
        <DialogTitle
          sx={{
            p: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: getColor.NeutralLightN60,
            textAlign: "center",
            position: "relative",
          }}
        >
          <Typography
            sx={{
              color: "#424752",
              fontSize: 16,
              fontFamily: fonts.manrope,
              fontWeight: "700",
              mt: "10px",
              flexGrow: 1,
              textAlign: "center",
            }}
          >
            {Title}
          </Typography>
          <IconButton
            onClick={() => handlClose(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 2,
              cursor: "pointer",
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            maxHeight: "400px",
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <Box sx={{ mt: "10px" }}>
            <Box sx={{ mb: 1, p: 3, position: "relative" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  mt: 2,
                  mb: 6,
                  textAlign: "center",
                }}
              >
                <Typography sx={{ color: getColor.NeutralDark700, mb: 2 }}>
                  Select PF Fund Type{" "}
                </Typography>
                <ToggleButtonGroup
                  value={alignment}
                  exclusive
                  onChange={(event, newAlignment) => {
                    if (newAlignment !== null) {
                      handleToggleChange(newAlignment);
                    }
                  }}
                  sx={{
                    backgroundColor: getColor.LightSlateGray,
                    borderRadius: "30px",
                    overflow: "hidden",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <ToggleButton
                    value="PPF"
                    sx={{
                      width: "100px",
                      border: "none",
                      borderRadius: "30px",
                      color: alignment === "PPF" ? "#000" : "#888",
                      backgroundColor:
                        alignment === "PPF"
                          ? getColor.PrimaryWhite
                          : "transparent",
                      fontWeight: "bold",
                    }}
                  >
                    PPF
                  </ToggleButton>
                  <ToggleButton
                    value="EPF"
                    sx={{
                      width: "100px",
                      border: "none",
                      borderRadius: "30px",
                      color: alignment === "EPF" ? "#000" : "#888",
                      backgroundColor:
                        alignment === "EPF"
                          ? getColor.PrimaryWhite
                          : "transparent",
                      fontWeight: "bold",
                    }}
                  >
                    EPF
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
              <Box>
                {alignment === "PPF" && (
                  <>
                    <TextInput
                      label="PPF Total Amount"
                      value={PPFCards.totalAmount}
                      onChange={(e) =>
                        handleFieldChangePPF("totalAmount", e.target.value)
                      }
                      type={"number"}
                      inputPropss={true}
                    />

                    <StyledDatePicker>
                      <DatePicker
                        selected={
                          PPFCards.tenure
                            ? new Date(PPFCards.tenure, 0, 1)
                            : null
                        }
                        onChange={(date) =>
                          handleFieldChangePPF("tenure", date)
                        }
                        onFocus={(e) => e.target.blur()}
                        placeholderText="Select Maturity Tenure"
                        showYearPicker
                        dateFormat="yyyy"
                        minDate={new Date()}
                        maxDate={
                          new Date(new Date().getFullYear() + 100, 11, 31)
                        }
                        dropdownMode="select"
                        popperPlacement="bottom"
                        popperProps={{
                          flip: {
                            behavior: ["bottom"], // don't allow it to flip to be above
                          },
                          preventOverflow: {
                            enabled: false, // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                          },
                          hide: {
                            enabled: false, // turn off since needs preventOverflow to be enabled
                          },
                          modifiers: [
                            {
                              name: "offset",
                              options: {
                                offset: [0, 10],
                              },
                            },
                            {
                              name: "preventOverflow",
                              options: {
                                padding: 8,
                              },
                            },
                            {
                              name: "zIndex",
                              options: {
                                zIndex: 1000, // Ensure the calendar is above other elements
                              },
                            },
                          ],
                        }}
                      />
                    </StyledDatePicker>
                  </>
                )}
                {alignment === "EPF" && (
                  <>
                    <TextInput
                      label="EPF Total Amount"
                      value={EPFCards.totalAmount}
                      onChange={(e) =>
                        handleFieldChangeEPF("totalAmount", e.target.value)
                      }
                      type={"number"}
                      inputPropss={true}
                    />

                    <StyledDatePicker>
                      <DatePicker
                        selected={
                          EPFCards.tenure
                            ? new Date(EPFCards.tenure, 0, 1)
                            : null
                        }
                        onChange={(date) =>
                          handleFieldChangeEPF("tenure", date)
                        }
                        onFocus={(e) => e.target.blur()}
                        placeholderText="Select Maturity Tenure"
                        showYearPicker
                        dateFormat="yyyy"
                        minDate={new Date()}
                        maxDate={
                          new Date(new Date().getFullYear() + 100, 11, 31)
                        }
                        dropdownMode="select"
                        popperPlacement="bottom"
                        popperProps={{
                          flip: {
                            behavior: ["bottom"], // don't allow it to flip to be above
                          },
                          preventOverflow: {
                            enabled: false, // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                          },
                          hide: {
                            enabled: false, // turn off since needs preventOverflow to be enabled
                          },
                          modifiers: [
                            {
                              name: "offset",
                              options: {
                                offset: [0, 10],
                              },
                            },
                            {
                              name: "preventOverflow",
                              options: {
                                padding: 8,
                              },
                            },
                            {
                              name: "zIndex",
                              options: {
                                zIndex: 1000, // Ensure the calendar is above other elements
                              },
                            },
                          ],
                        }}
                      />
                    </StyledDatePicker>
                  </>
                )}
              </Box>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ display: "flex", flexDirection: "column" }}>
          <Button
            variant="contained"
            onClick={handleSave}
            sx={{
              color: getColor.PrimaryWhite,
              fontSize: 16,
              fontFamily: fonts.manrope,
              fontWeight: "700",
              backgroundColor: getColor.ColorButtonPrimarysurface,
              width: "200px",
              mb: "20px",
              borderRadius: 4,
              textTransform: "inherit",
            }}
          >
            {String.Dashboard.Boxes.saveButton}
          </Button>
        </DialogActions>
      </Dialog>
      <CustomSnackbar
        open={snackbarOpen}
        handleClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={"error"}
      />
    </Card>
  );
};

export default ProfiduntFundModel;
